/**
 * Названия кампаний и кабинетов (спека Р4, §6.2). ID на экране не выводятся:
 * без названия — «Кампания без названия» / «Кабинет без названия».
 */
export const NO_CAMPAIGN_NAME = 'Кампания без названия';
export const NO_ACCOUNT_NAME = 'Кабинет без названия';
function clean(s) {
    const t = (s ?? '').trim();
    return t === '' ? null : t;
}
/**
 * Номера кампаний без названия внутри кабинета: «Кампания без названия № 2».
 * Хранятся по ОБЪЕКТУ кампании (WeakMap): номера раздаются один раз на ответ
 * отчёта (`numberUnnamedCampaigns` в `paybackApi.report`), и любой экран, фильтр,
 * сортировка и CSV, получившие тот же объект, видят один и тот же номер.
 */
const UNNAMED_NO = new WeakMap();
/** Числовые строки ID — по значению: сначала длина, потом лексикографически. */
const byIdValue = (a, b) => a.length !== b.length ? a.length - b.length : a < b ? -1 : a > b ? 1 : 0;
/**
 * Раздать номера кампаниям без названия: в каждом кабинете, где их больше
 * одной, — 1…N по возрастанию ID (порядок стабилен при любой сортировке
 * таблицы; сам ID на экран не выводится). Возвращает тот же массив.
 */
export function numberUnnamedCampaigns(campaigns) {
    const byAccount = new Map();
    for (const c of campaigns) {
        if (clean(c.campaignName) !== null)
            continue;
        const list = byAccount.get(c.accountId);
        if (list)
            list.push(c);
        else
            byAccount.set(c.accountId, [c]);
    }
    for (const list of byAccount.values()) {
        if (list.length < 2)
            continue;
        [...list]
            .sort((a, b) => byIdValue(a.campaignId, b.campaignId))
            .forEach((c, i) => UNNAMED_NO.set(c, i + 1));
    }
    return campaigns;
}
export function campaignTitle(c) {
    const name = clean(c.campaignName);
    if (name !== null)
        return name;
    const n = UNNAMED_NO.get(c);
    return n === undefined ? NO_CAMPAIGN_NAME : `${NO_CAMPAIGN_NAME} № ${n}`;
}
export function accountTitle(name) {
    return clean(name) ?? NO_ACCOUNT_NAME;
}
/**
 * Общий префикс названий, обрезанный до границы слова (` | ` или пробел):
 * «S | CBO 05.10 CCAP_21 | LAL 1% …» → dim «S | CBO 05.10 CCAP_21 | ».
 * Одно название или префикса нет — всё жирное. Названия, которые целиком
 * совпадают с префиксом, тоже жирные целиком.
 */
export function splitCommonPrefix(names) {
    if (names.length < 2)
        return names.map((n) => ({ dim: '', bold: n }));
    let prefix = names[0] ?? '';
    for (const n of names) {
        let i = 0;
        while (i < prefix.length && i < n.length && prefix[i] === n[i])
            i++;
        prefix = prefix.slice(0, i);
        if (prefix === '')
            break;
    }
    // До последней границы: после « | » или пробела.
    const bar = prefix.lastIndexOf(' | ');
    const sp = prefix.lastIndexOf(' ');
    // Граница « | » предпочтительнее, если она не сильно короче границы по пробелу.
    const cut = bar >= 0 && bar + 3 >= 0.6 * (sp + 1) ? bar + 3 : sp + 1;
    prefix = cut > 0 ? prefix.slice(0, cut) : '';
    if (prefix.trim() === '')
        return names.map((n) => ({ dim: '', bold: n }));
    return names.map((n) => n.length > prefix.length ? { dim: prefix, bold: n.slice(prefix.length) } : { dim: '', bold: n });
}
//# sourceMappingURL=campaign-name.js.map